import TheGrid from '@/views/redcases/grid'
import Edit from '@/views/redcases/edit'
import TheView from '@/views/redcases/view'

export default {
  path: '/redcases',
  redirect: '/redcases/index',
  name: 'redcases',
  meta: {
    auth: {
      redirect: {
        name: 'redcases.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Casos'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'redcases.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'redcases.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'redcases.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }, {
    path: 'view/:id',
    name: 'redcases.view',
    component: TheView,
    meta: {
      auth: true,
      label: 'Ver'
    }
  }]
}
